// extracted by mini-css-extract-plugin
module.exports = {"envelope":"index_envelope_rr76Y","hint":"index_hint_3Bx6v"};